
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CollapseFilterComponent } from '@app/components/collapse-filter/collapse-filter.component';
import { isNullish } from '@commonHelpers/math-utils';
import { NgbTooltip } from '@commonNodeModules/@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@commonNodeModules/@ngx-translate/core';
import { CatalogViewNewsShortDto } from '@interfaces/HttpClient/CatalogApiPublicModels';
import { CatalogViewService } from '@services/catalog-view.service';
import { InfocenterService } from '@services/infocenter.service';
import { NewNewsService } from '@services/new-news.service';

@Component({
	selector: 'app-news-list',
	templateUrl: './news-list.component.html',
	styleUrls: ['./news-list.component.scss'],
	providers: [CatalogViewService],
	imports: [NgbTooltip, TranslatePipe, CollapseFilterComponent]
})
export class NewsListComponent implements OnInit, OnChanges {

	constructor(
		private catalogViewService: CatalogViewService,
		private newNewsService: NewNewsService,
		private infocenterService: InfocenterService
	) { }


	public newsList: CatalogViewNewsShortDto[];
	@Output() openNews = new EventEmitter<number>();
	@Input() catalogKey: string;
	@Input() isMobile: boolean;
	public collapsed = false;
	public seenItems: number[] = []


	async ngOnInit() {
		if (isNullish(this.catalogKey)) {
			await this.getNewsList();
			await this.refreshItems();
		}

		this.newNewsService.refreshDb.subscribe(async () => this.refreshItems())
	}

	async ngOnChanges(changes: SimpleChanges) {
		if (changes.catalogKey?.currentValue) {
			await this.getNewsList();

			await this.refreshItems();
		}
	}

	private async getNewsList() {
		this.newsList = this.isMobile ?
			isNullish(this.catalogKey) ? await this.infocenterService.getInhouseNewsForDialog() : (await this.infocenterService.getCatalogNewsForDialog(this.catalogKey))?.catalogViewNews
			: await this.catalogViewService.getNewsForCatalogView(this.catalogKey);
	}

	private async refreshItems() {
		if (this.newsList) {
			this.seenItems = await this.newNewsService.getItems(this.catalogKey);  // Das Übergeben des Katalogkey macht Probleme wenn das Infocenter in der Katalogansicht angezeigt werden soll
		}
	}

	public openNewsList() {
		if (!this.isMobile) {
			this.openNews.emit();
		}
	}

	public collapse(isCollapsed: boolean) {
		this.collapsed = isCollapsed;
	}

}
